import "../../../../../../global.css";
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { LiveCode } from 'mdx-deck-live-code';
import IconGrid from "../../../../../../components/IconGrid";
import DecoupleLine from "../../../../../../components/DecoupleLine";
import Database from "../../../../../../components/Database";
import BusinessLogic from "../../../../../../components/BusinessLogic";
import API from "../../../../../../components/API";
import ABTest from "../../../../../../components/ABTest";
import Render from "../../../../../../components/Render";
import Components from "../../../../../../components/Components";
import DataFetching from "../../../../../../components/DataFetching";
import FeatureFlag from "../../../../../../components/FeatureFlag";
import { ZoomSteps } from "../../../../../../components/lib";
import Circle from "../../../../../../components/Circle";
import MovableCircle from "../../../../../../components/MovableCircle";
import AnimatedCircle from "../../../../../../components/AnimatedCircle";
import ReleaseSchedule from "../../../../../../components/ReleaseSchedule";
import StepCounter from "../../../../../../components/StepCounter";
import customTheme from "../../../../../../theme";
import onereqoneres from "../../../../../../images/one-req-one-res.png";
import onereqmanyres from "../../../../../../images/one-req-many-res.png";
import onereqmanyres1 from "../../../../../../images/one-req-many-res-1.png";
import onereqmanyres2 from "../../../../../../images/one-req-many-res-2.png";
import onereqmanyres3 from "../../../../../../images/one-req-many-res-3.png";
import onereqmanyres4 from "../../../../../../images/one-req-many-res-4.png";
import onereqmanyres4_1 from "../../../../../../images/one-req-many-res-4-1.png";
import onereqmanyres6 from "../../../../../../images/one-req-many-res-6.png";
import release from "../../../../../../images/release.png";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  LiveCode: LiveCode,
  IconGrid: IconGrid,
  DecoupleLine: DecoupleLine,
  Database: Database,
  BusinessLogic: BusinessLogic,
  API: API,
  ABTest: ABTest,
  Render: Render,
  Components: Components,
  DataFetching: DataFetching,
  FeatureFlag: FeatureFlag,
  ZoomSteps: ZoomSteps,
  Circle: Circle,
  MovableCircle: MovableCircle,
  AnimatedCircle: AnimatedCircle,
  ReleaseSchedule: ReleaseSchedule,
  StepCounter: StepCounter,
  customTheme: customTheme,
  onereqoneres: onereqoneres,
  onereqmanyres: onereqmanyres,
  onereqmanyres1: onereqmanyres1,
  onereqmanyres2: onereqmanyres2,
  onereqmanyres3: onereqmanyres3,
  onereqmanyres4: onereqmanyres4,
  onereqmanyres4_1: onereqmanyres4_1,
  onereqmanyres6: onereqmanyres6,
  release: release,
  React: React
};